function DownloadIcon({ size = 40, fill = 'none' }: { size?: number; fill?: string }) {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99998 13.157L6.44233 9.59938L7.32052 8.69554L9.375 10.75V3.75H10.625V10.75L12.6794 8.69554L13.5576 9.59938L9.99998 13.157ZM5.25642 16.25C4.83547 16.25 4.47917 16.1041 4.1875 15.8125C3.89583 15.5208 3.75 15.1645 3.75 14.7435V12.484H4.99998V14.7435C4.99998 14.8077 5.02669 14.8664 5.0801 14.9199C5.13353 14.9733 5.19231 15 5.25642 15H14.7435C14.8077 15 14.8664 14.9733 14.9199 14.9199C14.9733 14.8664 15 14.8077 15 14.7435V12.484H16.25V14.7435C16.25 15.1645 16.1041 15.5208 15.8125 15.8125C15.5208 16.1041 15.1645 16.25 14.7435 16.25H5.25642Z"
          fill="black"
        />
      </svg>
    </>
  );
}

export default DownloadIcon;
